import styled from 'styled-components';

const LoadingMessage = styled.div`
  font-size: 1.5rem;
  color: rgba(130, 22, 146, 1);
  text-align: center;
`;

export default LoadingMessage;
